export var CalloutSize;
(function (CalloutSize) {
    CalloutSize["SMALL"] = "small";
    CalloutSize["MEDIUM"] = "medium";
})(CalloutSize || (CalloutSize = {}));
